<template>
    <form ref="formElement" @submit.prevent="submit">
        <div v-if="errorMessage" class="alert alert-danger mt-1">{{ errorMessage }}</div>
        <slot></slot>
    </form>
</template>

<script lang="ts" setup>
import type {Dictionary} from "../types.ts";
import {ref, watch} from "vue";
import axios, {type AxiosError} from "axios";

interface Props {
    postUrl: string
    slug: string
}

const {postUrl, slug} = defineProps<Props>();

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const formElement = ref<HTMLFormElement>();

const errorMessage = ref<false | string>(false);

const semaphore = ref(0);

watch(semaphore, value => {
    if (value > 0) {
        document.querySelector('#msg-modal button')?.setAttribute('disabled', 'disabled');
    } else {
        document.querySelector('#msg-modal button')?.removeAttribute('disabled');
    }
});

const submit = () => {
    semaphore.value++;
    clearValidation();
    errorMessage.value = false;

    const formData = new FormData(formElement.value);

    axios.post(postUrl + slug, formData)
        .then(response => {
            document.querySelectorAll('#msg-modal .msg-step1')?.forEach((element) => {
                (element as HTMLElement).classList.add('d-none');
            });
            document.querySelectorAll('#msg-modal .msg-step2')?.forEach((element) => {
                (element as HTMLElement).classList.remove('d-none');
            });
        })
        .catch((error: AxiosError) => {
            if (error.response) {
                if (error.response.status === 422) {
                    Object.entries(error.response.data as Dictionary<string>).forEach(([name, message]) => {
                        const inputElement = formElement.value?.querySelector(`input[name=${name}], textarea[name=${name}], select[name=${name}]`);
                        if (inputElement) {
                            inputElement.classList.add('is-invalid');
                            const invalidFeedbackElement = inputElement.parentElement?.querySelector('div.invalid-feedback');
                            if (invalidFeedbackElement) {
                                invalidFeedbackElement.innerHTML = message;
                            }
                        }
                    })
                } else {
                    errorMessage.value = 'Ein Fehler ist aufgetreten, versuche es später erneut.'
                }
            }
        })
        .finally(() => {
            semaphore.value--;
        })
}

const clearValidation = () => {
    const inputElements = formElement.value?.querySelectorAll('input[name], textarea[name], select[name]');
    inputElements?.forEach(node => {
        const element = node as HTMLInputElement;
        element.classList.remove('is-invalid');
    });
}
</script>
